<template>
  <vx-card class="mt-base">
    <h4 class="mb-5">"Real World" Experience</h4>
    <div class="user-bio mb-5">
      <h5 class="mb-3">Host Business Name</h5>
      <p>{{ this.experience.vje.name }}</p>
    </div>

    <div class="user-bio mb-5">
      <h5 class="mb-3">Work Experience Start Date:</h5>
      <p>{{ this.experience.date_started_formatted }}</p>
    </div>
    <div class="user-bio mb-5">
      <h5 class="mb-3">Work Experience End Date:</h5>
      <p>{{ this.experience.date_completed_formatted }}</p>
    </div>
  </vx-card>
</template>

<script>
import store from '@/store/store';

export default {
  computed: {
    experience() {
      const loginType = localStorage.getItem('login_type');
      if (loginType == 'student') {
        const experiences = store.getters['authStudent/experiences'];
        return experiences.find((i) => i.id == this.$route.params.id);
      } else {
        return store.getters['authTeacher/experience'];
      }
    },
  },
};
</script>
